<div class="dialog-content-wrapper">
  <mat-toolbar mat-dialog-title class="mat-accent m-0">
    <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">PDF Viewer</span>
      <button (click)="thisDialog.close()" aria-label="Close dialog">
        <mat-icon class="closebtn">close</mat-icon>
      </button>
    </div>
  </mat-toolbar>
  <mat-progress-bar *ngIf="loading" mode="query" class="my-color" mode="query" value="value"
    [bufferValue]="bufferValue"></mat-progress-bar>

  <div>
    <iframe [src]="data | safe" style="min-width:100vw;min-height: 100vh;"></iframe>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/main/content/common/pdf-modal-view/pdf-modal-view.component.html